import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';

const GenericSelection = props => (
  <div>
    <label htmlFor="selection" className="control-label">
      <span className="selection-label">{ props.translation }{(props.colon) ? ':' : ''}</span>
      <Select
        id="selection"
        className="selection-dropdown"
        clearable={false}
        value={props.value}
        options={props.options}
        onChange={(e) => { props.setSelected(e); }}
        disabled={props.disabled}
        placeholder={props.placeholder}
      />
    </label>
  </div>
);

GenericSelection.defaultProps = {
  translation: '',
  disabled: false,
  colon: false,
};

GenericSelection.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.shape({}).isRequired,
  setSelected: PropTypes.func.isRequired,
  translation: PropTypes.node,
  disabled: PropTypes.bool,
  colon: PropTypes.bool,
};

export default GenericSelection;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/GenericSelection.jsx